<template>
    <v-dialog
            v-model="isDialog"
            style="z-index: 733;"
            persistent
            max-width="500"
            :light="true"
    >
        <v-card v-if="isDialog" @click="installNow">
            <div class="safeScroll">
                <!--            <div class="absX" @click.passive="closeDialog">X</div>-->
                <!--            <div class="spacer-25"></div>-->
                <v-card-title class="headline">Möchtest du ein Icon für die App hinzufügen?
                </v-card-title>
                <!--            <v-card-title class="headline">Install {{$store.getters.storeName}} <span class="text-nowrap">&nbsp;LIKE A BOSS:</span>-->
                <!--            </v-card-title>-->

                <!--            v-on:submit.prevent-->
                <!--            form is required to react on virtual keyboard done event-->
                <v-card-text class="text-left">
                    Du kannst die App jetzt in sekundenschnelle installieren, ohne Download!
<!--                    auch ohne Internet benutzen, egal ob mit oder ohne Lesezeichen.-->
<!--                    <div class="text-center pt-3">-->
<!--                        <a href="#" @click.passive="pwaReadMore">&gt;&gt; So geht's &lt;&lt;</a>-->
<!--                    </div>-->


                    <!--                <div>Drücke im Menü auf den Button <strong>Installieren</strong>:</div>-->
                    <!--                <img src="https://liefermaxx.s3.eu-central-1.amazonaws.com/images/Install-Liefermaxx-PWA.gif"-->
                    <!--                     style="width: 280px; height: auto"-->
                    <!--                >-->
                    <!--                <div style="height: 15px"></div>-->
                    <!--                <div><h2>Über folgenden Button startest du die Installation</h2></div>-->
                    <!--                <img style="width: 182px; height: auto" src="https://liefermaxx.s3.eu-central-1.amazonaws.com/images/PWA-Install.jpg">-->

                </v-card-text>


                <!--            <v-card-actions class="text-center d-block">-->
                <div class="pa-1 text-center">
                    <v-btn class="okBtn ma-2 btn-df" rounded large text @click.native.passive.stop="installNow">
                        Hinzufügen
                    </v-btn>
                    <div class="mt-4 underline text-center">
                        <span @click.passive.stop="closeDialog" class="pointer">Abbrechen</span>
                    </div>
                </div>
                <!--            </v-card-actions>-->
                <div class="pb-3"></div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    // import store from '../store/store'
    import {ebus} from '../vendor/ebus';

    export default {
        props: {
            dialog: Boolean,
        },
        data() {
            return {
                isDialog: false,
            }
        },
        // beforeCreate(){
        //     util.enableNoScroll(true)
        // },
        // beforeDestroy(){
        //     util.enableNoScroll(false)
        // },
        watch: {
            dialog(newValue) {
                this.isDialog = newValue;
                if (newValue) {

                }
            },
            isDialog(newValue) {
                if (!newValue) {
                    // this.ready = false;
                    this.$emit('close');
                }
            },
            // install() {
            //     ebus.$emit('userWantsToInstall');
            // }
        },

        methods: {
            closeDialog() {
                this.isDialog = false;
            },
            pwaReadMore() {
                this.$router.push({name: 'Beitrag', params: {tag: 'AppInstallation'}});
                this.installNow();
                return false;
            },
            installNow() {
                this.closeDialog();
                ebus.$emit('userWantsToInstall');
            }
        }
    }
</script>

<style lang="scss" scoped>

    /*.vvd{*/
    /*    >>> .v-dialog{*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/
</style>